import PieChart from "../../components/PieChart";
import api from '../../config/api'
import { useState, useEffect } from 'react'

import { useAuth } from '../../contexts/auth'



interface Order {
    order_id: number,
    user: string,
    customer: string,
    affiliated: boolean,
    capital: boolean,
    branch: number,
    product: number,
    quantity: number,
    datetime: Date
}

interface PieData {
    id: string,
    label: string,
    value: number,
    color: string
}

function Dashboard() {

    const [orders, setOrders] = useState<Order[]>([])
    const [capitalPieData, setCapitalPieData] = useState<PieData[]>([])


    useEffect(() => {
        async function fetch() {
    
            const responseOrders = await api.get('/orders')
            setOrders(responseOrders.data.orders)

            let capitalCount = 0
            let affiliatedCount = 0

            responseOrders.data.orders.map((order: Order) => {
                if (order.capital) {
                    capitalCount++;
                }
                if (order.affiliated) {
                    affiliatedCount++;
                }
            })
            capitalPieData.push({
                id: 'go',
                label: 'go',
                color: '#00ff00',
                value: capitalCount
            })
            capitalPieData.push({
                id: 'c',
                label: 'c',
                color: '#ff0000',
                value: responseOrders.data.orders.length - capitalCount
            })

        }

        fetch()
    }, [])

    const data = [
        {
            "id": "go",
            "label": "go",
            "value": 40,
            "color": "hsl(274, 70%, 50%)"
        },
        {
            "id": "c",
            "label": "c",
            "value": 560,
            "color": "hsl(236, 70%, 50%)"
        }
    ]

    return (
        <div style={{ height: 500 }}>
            {
                capitalPieData.length > 2 &&
                <PieChart data={capitalPieData} />

            }
        </div>

    );
}


export default Dashboard